import { useTranslate } from '@ur-solutions/react-hooks'
import { ExportDriverActivitiesCard } from '../components'
import { ExportSection } from '../components/ExportsSettings/components'
import { ExportUnknownDriverLocations } from '../components/ExportsSettings/ExportUnknownDriverLocations'
import { useModuleConfig } from '@/utils/hooks'
import { Module, ModuleOptionsValue } from '../../consts'

export function ExportActivities() {
  const translations = useTranslate({
    activities: 'common.activities',
  })

  const { getModuleOption } = useModuleConfig(Module.ACTIVITIES)

  const moduleOptionActive = getModuleOption(
    ModuleOptionsValue.ACTIVITIES_PROCESS_TACHO_FILES
  )

  return (
    <ExportSection header={translations.activities}>
      <ExportDriverActivitiesCard />
      {moduleOptionActive && <ExportUnknownDriverLocations />}
    </ExportSection>
  )
}
